import React, {useState, useEffect} from "react";
import {Select} from "antd";
import {useController} from "react-hook-form";

import {trb} from "@utilities";

const Option = Select.Option;

export const SelectFormField = ({
                                    title,
                                    error,
                                    size,
                                    control,
                                    name,
                                    isClearable,
                                    isSearchable,
                                    options = [],
                                    optionsValue,
                                    optionsLabel,
                                    className = "",
                                    defaultValue,
                                    onChange,
                                    ...rest
                                }) => {
    const {field, fieldState} = useController({
        control,
        name,
        ...(defaultValue && {defaultValue})
    });
    const [isLabelFloating, setIsLabelFloating] = useState(field.value);
    
    useEffect(() => {
        setIsLabelFloating(field.value);
    }, [field.value]);
    
    return (
        <div
            className={`form-field-wrapper row  ${className}`}
        >
            {title && (
                <div className="form-field-title col-12">
                    {title}
                </div>
            )}
            <div className={`form-field-item col-12 ${error ? "has-error" : ""}`}>
                <Select
                    {...rest}
                    {...field}
                    allowClear={isClearable}
                    showSearch={isSearchable}
                    placeholder={null}
                    filterOption={(input, option) =>
                        option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                    }
                    getPopupContainer={trigger => trigger.parentNode}
                    size={size}
                    onFocus={() => setIsLabelFloating(true)}
                    onChange={e => {
                        field.onChange(e);
                        if (onChange) {
                            onChange(e);
                        }
                    }}
                    onBlur={e => {
                        setIsLabelFloating(!!field.value);
                        field.onBlur(e);
                    }}
                    style={{width: '100%'}}
                >
                    {options.map(item => (
                        <Option value={item[optionsValue]} key={item?.[optionsValue]}>
                            {trb(item?.[optionsLabel])}
                        </Option>
                    ))}
                </Select>
                {fieldState?.error?.message && (
                    <div className="form-field-error">
                        {fieldState.error.message}
                    </div>
                )}
            </div>
        </div>
    );
};
